import { VariableType } from 'json-to-graphql-query';

import { Resource } from './resource';

/**
 * Resource MDOK
 *
 * @export
 * @class MdokResource
 * @extends {Resource}
 */
export class MdokResource extends Resource {
  /**
   * Pobiera nazwę dokumentu z MDOK
   *
   * @param {*} variables
   * @returns {Promise<string>}
   * @memberof MdokResource
   */
  public getDocumentName(variables: any): Promise<string> {
    const query = this.prepareOptions({
      query: {
        __variables: { uid: 'Int!', documentId: 'Int' },
        mdokDocumentName: { __args: { uid: new VariableType('uid'), documentId: new VariableType('documentId') } }
      }
    });
    return this.query({ query, variables }, 'mdokDocumentName');
  }

  /**
   * Pobiera nazwę sprawy z MDOK
   *
   * @param {*} variables
   * @returns {Promise<string>}
   * @memberof MdokResource
   */
  public getCaseName(variables: any): Promise<string> {
    const query = this.prepareOptions({
      query: {
        __variables: { uid: 'Int!', documentId: 'Int' },
        mdokCaseName: { __args: { uid: new VariableType('uid'), documentId: new VariableType('documentId') } }
      }
    });
    return this.query({ query, variables }, 'mdokCaseName');
  }
}

export const mdokResource = new MdokResource();
